import { render, staticRenderFns } from "./AllMaglie.vue?vue&type=template&id=011c608e&scoped=true&"
import script from "./AllMaglie.vue?vue&type=script&lang=js&"
export * from "./AllMaglie.vue?vue&type=script&lang=js&"
import style0 from "./AllMaglie.vue?vue&type=style&index=0&id=011c608e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011c608e",
  null
  
)

export default component.exports